import React, {useState} from "react";
import {Form} from "antd";

import HeaderFormEditSensorNames from "./HeaderForm";
import SensorForm from "./SensorForm";
import EditNamesHeader from "./EditNamesHeader";
import {SensorNames, SensorNamesArray} from "../../../store/branches/sensors/stateTypes";
import SensorFormF500 from "./SensorFormF500";

import classes from "../EditSensorsNames.module.scss";


interface UserSettingFormProps {
    onSubmit?: (values: any) => void
    onCancel?: () => void
    form?: any
    deviceTitle?: string
    sensorNames?: SensorNames
    device_type?: string
    device_subtype?: string
}

const EditSensorsNamesForm: React.FC<UserSettingFormProps> = ({
                                                                  onSubmit,
                                                                  onCancel,
                                                                  form,
                                                                  deviceTitle,
                                                                  sensorNames,
                                                                  device_type,
                                                                  device_subtype
                                                              }) => {
    const [isRefresh, setRefresh] = useState<boolean>(false)

    return (
        <div className={"header-link"}>
            <Form name="sensor_names"
                  form={form}
                  onFinish={onSubmit}
            >

                <HeaderFormEditSensorNames onCancel={onCancel}/>

                <div className={classes.sensorsNamesInputsWrap}>
                    <EditNamesHeader deviceTitle={deviceTitle} form={form} setRefresh={setRefresh}/>

                    <div className={classes.container}>
                        {
                            device_type === "F500-UDF"
                            &&
                            <SensorFormF500 sensorGroupF500={sensorNames.networks}
                                            degrees={sensorNames.degrees}
                                            form={form}
                                            isRefresh={isRefresh}
                            />

                        }

                        {sensorNames?.sensor_names?.map((sensorGroup: SensorNamesArray, index: number) => (
                            <SensorForm sensorGroup={sensorGroup}
                                        isRefresh={isRefresh}
                                        key={`sensor_group_name${index}${sensorGroup.name}`}
                                        form={form}
                                        device_subtype={device_subtype}

                            />
                        ))}

                    </div>
                </div>
            </Form>
        </div>
    );
};

export default EditSensorsNamesForm;
